import React, {useMemo, useState} from "react";
import classNames from "classnames";
import ARControlList from "../ARControlList";
import {useTranslation} from "react-i18next";
import {generateEvent} from "../../../utils";
import {useController} from "react-hook-form";
import {CFormGroup, CInput, CInputGroup} from "@coreui/react";
import {getObjectValuesByTypes} from "./ARElementsSelector.model";
import {sortArraysAndReturnNotEqualItems} from "../../../../../utils/arrays";

const ARElementsSelector = (props) => {
  const {
    id,
    name,
    items,
    control,
    className,
    getItemText,
    selectedItemsPrependComponent,
    unselectedItemsPrependComponent,
  } = props;

  const {t} = useTranslation();
  const [filterInputValue, setFilterInputValue] = useState("");
  const {field: {value, onChange}} = useController({name, control});

  const onAddItemClick = ({item, event}) => {
    const newValue = [...value, item];
    const newEvent = generateEvent({event, newValue});

    onChange(newEvent);
    setFilterInputValue("");
  };

  const onDeleteItemClick = ({item, event}) => {
    const newValue = value.filter(selectedItem => selectedItem.id !== item.id);
    const newEvent = generateEvent({event, newValue});
    onChange(newEvent);
  };

  const unselectedItems = useMemo(() =>
    sortArraysAndReturnNotEqualItems(
      items.filter(
        item => new RegExp(filterInputValue, "gi")
          .test(getObjectValuesByTypes(item, ["string", "number"]).join(" "))),
      value
    ), [filterInputValue, value, items]);

  const filterInputHandler = (event) => setFilterInputValue(event.target.value);

  return (
    <CFormGroup className={classNames(className)}>
      <ARControlList
        items={value}
        getItemText={getItemText}
        onActionIconClick={onDeleteItemClick}
        prependComponent={selectedItemsPrependComponent}
        emptyText={t("noData.empty", "Empty")}
        actionIconProps={{
          name: "cilXCircle",
          className: "delete-circle"
        }}
      />
      <CInputGroup className="mt-1">
        <CInput
          id={id}
          autoComplete="off"
          value={filterInputValue}
          onInput={filterInputHandler}
          placeholder={t("search.default", "Search")}
          className="mb-1 w-75 field_right-border-radius"
        />
        <ARControlList
          getItemText={getItemText}
          onActionIconClick={onAddItemClick}
          items={!!filterInputValue ? unselectedItems : []}
          prependComponent={unselectedItemsPrependComponent}
          emptyText={items.length !== value.length ?
            t("noData.startTyping", "Start typing to search") :
            t("noData.empty", "Empty")}
          actionIconProps={{
            name: "cilXCircle",
            className: "add-circle"
          }}
        />
      </CInputGroup>
    </CFormGroup>
  );
};

ARElementsSelector.defaultProps = {
  items: []
};

export default ARElementsSelector;
